import { useState } from "react";

import usePromotions from "common/datahooks/usePromotions";
import useWorkspaces from "common/datahooks/useWorkspaces";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import DesktopTable from "./DesktopTable";
import MobileList from "./MobileLayout/MobileList";

export default function WorkspacesTable() {
  const isDesktop = useTwBreakpoint("lg");
  const { workspaces } = useWorkspaces();
  const { ltdPromotion, appSumoPromotion } = usePromotions();
  const promotion = ltdPromotion ?? appSumoPromotion;

  const [editingWorkspaceId, setEditingWorkspaceId] = useState<string>();

  if (!promotion) {
    return null;
  }

  const filteredWorkspaces = workspaces
    ? workspaces.filter(({ role }) => role === "owner")
    : [];

  const Component = isDesktop ? DesktopTable : MobileList;

  return (
    <Component
      workspaces={filteredWorkspaces}
      editingWorkspaceId={editingWorkspaceId}
      setEditingWorkspaceId={setEditingWorkspaceId}
    />
  );
}
